import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSnackbar } from '../../hooks/useAppSnackbar';
import { ErrorStateType } from '../../models/common';
import { riskApi } from '../../utils/api';
import { setErrorStateSnacks } from '../../utils/error';
import { QcsBox } from '../common/basic/QcsBox';
import { QcsButton } from '../common/basic/QcsButton';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../common/basic/QcsModalBox';
import { SaveError } from '../common/SaveError';
import { SectionHeader } from '../common/SectionHeader';

interface Props {
  open: boolean;
  riskVersionId: string;
  onClose: () => void;
  reloadRiskList: () => void;
}

export const RiskVersionDeleteModal: FC<Props> = ({
  open,
  riskVersionId,
  onClose,
  reloadRiskList,
}) => {
  const { t } = useTranslation();
  const { enqueueSuccessSnackbar, enqueueErrorSnackbar } = useAppSnackbar();
  const [saveError, setSaveError] = useState<ErrorStateType>();

  useEffect(() => {
    setSaveError('');
  }, [open]);

  const confirmDelete = async () => {
    try {
      await riskApi.deleteRiskVersion(riskVersionId);
      enqueueSuccessSnackbar(t('risk.versionDeleted'));
      reloadRiskList();
      onClose();
    } catch (err) {
      setErrorStateSnacks(
        err,
        setSaveError,
        enqueueErrorSnackbar,
        'risk.versionDeleteError'
      );
    }
  };

  return (
    <QcsModal open={open} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title={t('risk.askDeleteVersion')} />
        <QcsBox sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <QcsButton variant="contained" onClick={confirmDelete}>
            {t('common.yes')}
          </QcsButton>
          <QcsButton variant="outlined" onClick={onClose}>
            {t('common.no')}
          </QcsButton>
        </QcsBox>
        <QcsBox sx={{ display: 'flex', m: 1, justifyContent: 'center' }}>
          <SaveError error={saveError} />
        </QcsBox>
      </QcsModalBox>
    </QcsModal>
  );
};
